import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { CakeItEasyWebUiModule, UiFullSizeImageComponent } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';

import {
  ProductAvailabilityInfoComponent
} from './components/product-availability-info/product-availability-info.component';
import { ProductQuantityInfoComponent } from './components/product-quantity-info/product-quantity-info.component';
import { ProductImgComponent } from './components/product-img/product-img.component';
import { ProductImageGalleryComponent } from './components/product-image-gallery/product-image-gallery.component';
import {
  ProductSoldOutDatesInfoComponent
} from './components/product-sold-out-dates-info/product-sold-out-dates-info.component';


@NgModule({
  declarations: [
    ProductQuantityInfoComponent,
    ProductAvailabilityInfoComponent,
    ProductSoldOutDatesInfoComponent,
    ProductImgComponent,
    ProductImageGalleryComponent,
  ],
  imports: [
    CommonModule,
    CakeItEasyWebUiModule,
    NgCakeItEasyUtilsModule,
    TranslateModule,
    RouterModule
  ],
  exports: [
    ProductQuantityInfoComponent,
    ProductAvailabilityInfoComponent,
    ProductSoldOutDatesInfoComponent,
    ProductImgComponent,
    ProductImageGalleryComponent,
  ],
})
export class SharedModule { }
